export default {
    maintenance: false,
    notification: {
        icon: null,
        title: null
    },
    allNotifications: [],
    lastNotificationsPageIndex: 1,
    currentNotificationsPageIndex: 1,
    isLoading: false
}
